import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	paginacao: paginacaoListagem([], 25),
	filtro: {
		descricao: {
			default: null,
			label: 'Pesquisa',
			value: null,
		},
	},
}
